export default __webpack_public_path__ + "static/media/G0007.fc83aeaa.png";